import {
  FILE_EDI_RECORD_REQUEST,
  FILE_EDI_RECORD_SUCCESS,
  FILE_EDI_RECORD_FAILURE,
  CLEAR_FILE_SUCCESS_POPUP,
} from "../actionTypes";

import edi from "../service/cbp";

const fileEdiRequest = () => {
  return {
    type: FILE_EDI_RECORD_REQUEST,
  };
};

const fileEdiRequestSuccess = (recordFiled) => {
  return {
    type: FILE_EDI_RECORD_SUCCESS,
    payload: recordFiled,
  };
};
export const clearFileSuccessPopup = () => {
  return {
    type: CLEAR_FILE_SUCCESS_POPUP,
  };
};
export const fileEdiRequestFailure = (error) => {
  return {
    type: FILE_EDI_RECORD_FAILURE,
    payload: error,
  };
};

export const fileRequest = (
  selectedRow,
  retransmit,
  shipmentid,
  PopUprecords,
  country,
  fileHMRC,
  email,
  token,
  fileCBSA = null,
  reason,
  usFormType,
  documentType
) => {
  return async (dispatch) => {
    dispatch(fileEdiRequest());
    let response = await edi.FileEdiRequest(
      selectedRow,
      retransmit,
      shipmentid,
      PopUprecords,
      country,
      fileHMRC,
      email,
      token,
      fileCBSA,
      reason,
      usFormType,
      documentType
    );
    const requestFiledMessage = response.data;
    dispatch(fileEdiRequestSuccess(requestFiledMessage));
    return requestFiledMessage;
  };
};
